/**
 * The support inbox's unread count, for the sidebar chip.
 *
 * It shares the Inbox tab's own counts query (production tickets only), so on
 * the inbox screen the chip and the tab counts are one request, re-read every
 * 15 seconds. A failed or missing read is zero: the chip disappears rather
 * than taking the nav item down with it.
 */
import { useQuery } from "@tanstack/react-query";

import { supportInboxCountsQuery } from "@/lib/queries";
import type { InboxCounts } from "@/types-support";

function inboxUnreadFrom(data: InboxCounts | undefined): number {
  const value = data?.unread;
  return typeof value === "number" && value > 0 ? value : 0;
}

export function useInboxUnreadCount(): number {
  const { data } = useQuery({
    ...supportInboxCountsQuery(),
    select: inboxUnreadFrom,
  });
  return data ?? 0;
}
